import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    Input,
    OnInit,
} from "@angular/core";
import { Chart, ChartType } from "chart.js";
import { DataStructureStatistics } from "../data-structure";

@Component({
    selector: "app-radar-chart",
    templateUrl: "./radar-chart.component.html",
    styleUrls: ["./radar-chart.component.scss"],
})
export class RadarChartComponent implements OnInit {
    @Input() data: DataStructureStatistics;
    public chart: Chart;

    constructor(
        private cdr: ChangeDetectorRef,
        private elementRef: ElementRef
    ) {}

    ngOnInit(): void {}

    ngOnChanges(): void {
        this.createChart();
    }

    private createChart(): void {
        if (!this.data) {
            console.warn("Data is not available to create the chart.");
            return;
        }

        // Obtain the parent div in the parent component IMPORTANT: the parent must have a div with class chart-container
        const container =
            this.elementRef.nativeElement.closest(".chart-container");
        if (!container) {
            console.error("Chart container element not found.");
            return;
        }

        let canvas_container = container.getElementsByClassName(
            "chart-container-radar"
        )[0];
        canvas_container.innerHTML = "";

        // Create a canvas and assign to a canvas container
        const canvas = document.createElement("canvas");
        canvas.id = this.data.chartName; // Asignar el ID basado en el nombre del gráfico
        canvas_container.appendChild(canvas);

        // get context 2d
        const ctx = canvas.getContext("2d");
        if (!ctx) {
            console.error("Failed to get 2D context from canvas element.");
            return;
        }

        // Create the graphic using the 2D context
        this.chart = new Chart(ctx, {
            type: "radar" as ChartType,
            data: {
                labels: this.data.labels,
                datasets: this.data.datasets,
            },
            options: {
                plugins: {
                    legend: {
                        position: "top",
                        display: true,
                        labels: {
                            boxHeight: 30,
                        },
                    },
                },
                responsive: true,
                maintainAspectRatio: false,
                layout: {
                    padding: {
                        left: 50, // Ajusta este valor según sea necesario para centrar el gráfico
                        right: 50, // Ajusta este valor según sea necesario para centrar el gráfico
                        top: 0,
                        bottom: 0,
                    },
                },
            },
        });
    }
}
